import { keyBy } from '@speechki-frontend/shared/helpers/functions';

export const normalizeBookparts = _bookparts => {
    const bookpartsList = [];
    const bookparts = keyBy(_bookparts, 'id', bp => {
        bookpartsList.push(bp.id);
    });

    return { bookparts, bookpartsList };
};
